import React, { Component } from "react";
import "./gastos.scss";
import { Col, Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'

const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class RegistrosGastosPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arraySucursales: [],
      id_sucursal: '0',
      date: this.getDateGeneric(),
      typeProduct: 0,
      arrGastos: [],
      totalGastos: {
        gastos: 0,
      }
    }
  }

  getDateGeneric(opt) {
    if(opt === 0)
      return (new Date())
    else {
      let d = new Date()
      d.setMonth(6)
      return new Date(d)
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getProgreso()
  }

  getProgreso() {
    const { id_sucursal, date, typeProduct, } = this.state

    const data = {
      user: 'admin',
      tab: this.props.initState.tabProgresoActive,
      id_sucursal, date, typeProduct
    }
    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=appGetGastos", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...data, }),
    })
    .then(response => response.json())
    .then((response) => {
      let { arraySucursales, arrGastos, } = response

      this.setState({
        arraySucursales,
        arrGastos,
        // arrDiasVenta: arrDiasVenta.array,
        // arrDiasGasto: arrDiasGasto.array,
        // totalVentas: {
        //   kg: total_kg,
        //   pesos: total_pesos
        // },
        // totalGastos: {
        //   gastos: arrDiasGasto.total_gastos
        // }
      })
    }).catch((error) => console.log(error));
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout( () => {
      this.getProgreso()
    }, 100)
  }

  getAmountByDay(type) {
    /*
    let { date, arrDiasVenta, arrDiasGasto, } = this.state
    const dia = moment(date).format('DD')

    if(arrDiasVenta.length === 0)
      return 0

    if(type === 'venta') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos, 2 )
    } else if(type === 'gasto') {
      return this.number_format( arrDiasGasto[ dia - 1 ].valor, 2 )
    } else if(type === 'utilidad') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos - arrDiasGasto[ dia - 1 ].valor, 2 )
    }

    */
    return 0
  }

  render() {
    const { arraySucursales, viewForm } = this.state
    // const porcMeta = this.getProgressMeta()

    return (
      <Container className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row>
          <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', }}>
            {
              arraySucursales.length > 0 ?
                <Select
                  placeholder="Dirección"
                  // defaultInputValue="Dirección"
                  options={this.state.arraySucursales}
                  onChange={(val) => {this.handleInputChange(val)}}
                  styles={customStyles} />
              : null
            }

            {/* Gauge global information */}

            { !viewForm ? this.makeListGastos() : this.makeFormGastos() }


          </div>
        </Row>

      </Container>
    );
  }

  makeListGastos() {
    const { arrGastos, date } = this.state

    return (
      <Container style={{ backgroundColor: '#fff', borderRadius: 4, }}>
        <Row>
          <Col className="gastosPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.goToDay(0) }>Atrás</p>
          </Col>
          <Col className="gastosPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', }}>{ moment(date).format('DD/MM/YYYY') }</p>
          </Col>
          <Col className="gastosPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.goToDay(1) }>Adelante</p>
          </Col>
        </Row>

        <br />

        <p onClick={() => { this.onCreateGasto() }} style={{ textAlign: 'right', cursor: 'pointer', }}>REGISTRAR</p>
        {
          arrGastos.map((t,e) => (
            <>
              <h4>{t.nombre}</h4>
              <table style={{ width: '100%', }}>
                <thead style={{ width: '100%', }}>
                  <tr>
                    <th>Concepto</th>
                    <th>Cantidad</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody style={{ width: '100%', }}>
                {
                  t.arr.array.map((t0, e0) => (
                    <tr>
                      <td className="gastosPage__formTitle">
                        <p>{t0.nombre}</p>
                        <p style={{ fontStyle: 'italic', color: '#777', fontSize: '.8rem', }}>Sin descripción</p>
                      </td>
                      <td>
                        <p><b style={{ fontSize: '1.4rem', }}>${ this.number_format(t0.valor) }</b></p>
                      </td>
                      <td>
                        <p>Editar</p>
                        <img src="img/pos/wrong.png" alt="banner" style={{ width: 32, height: 32, objectFit:'contain', borderRadius: '100%', padding: 5, }} />
                      </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
              <p>Total: ${ this.number_format(t.arr.total_gasto) }</p>
              <hr />
            </>
          ))
        }
      </Container>
    )
  }

  onCreateGasto() {
    if(this.state.id_sucursal !== '0') {
      this.setState({viewForm: true})
    } else {
      alert('Por favor, elige una sucursal para registrar su gasto.')
      return false
    }
  }


  makeFormGastos() {
    return (
      <Container style={{ backgroundColor: '#fff', display: 'table', borderRadius: 4, flex: 1, }}>

        <h4 style={{ textAlign: 'center', margin: 20, paddingTop: 10, }}>Registrar un gasto</h4>
        <div className="gastosPage__formRegister">
          <p style={{ fontSize: '1.3rem', margin: 0, marginTop: 10, color: '#777', }}>CONCEPTO</p>
          <input type="text" />
          <p style={{ fontSize: '1.3rem', margin: 0, marginTop: 10, color: '#777', }}>DESCRIPCIÓN</p>
          <input type="text" />
          <p style={{ fontSize: '1.3rem', margin: 0, marginTop: 10, color: '#777', }}>CANTIDAD</p>
          <input type="text" />
        </div>

        <button className="gastosPage__formBtn" onClick={() => { this.setState({viewForm: false}) }}>Agregar</button>

      </Container>
    )
  }

  getProgressMeta() {
    let utilidad = this.getAmountByDay('utilidad')
    let meta = 0

    if(utilidad !== 0) {
      utilidad = utilidad.replace('$', '').replace(',', '')
      meta = ((utilidad / 15000) * 100)
    }

    return {
      porc: (meta > 100 ? 100 : meta) + '%',
      val: meta
    }
  }

  goToDay(opt) {
    const { date, arrGastos } = this.state
      let d = new Date(date)

    const dia = moment(date).format('DD')
    if(opt === 0) {
      //Pa atrás
      let dayAnt = parseInt(dia) - 1
      if(dayAnt < 1) {
        return false
      }
      d.setDate( dayAnt )
      this.setState({
        date: new Date(d)
      })
    } else {
      //Pa adelante

      let dayNext = parseInt(dia) + 1
      if(parseInt(dayNext) > arrGastos.length) {
        return false
      }
      d.setDate( dayNext )
      this.setState({
        date: new Date(d)
      })
    }

  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

};

export default withRouter(RegistrosGastosPage)